import React from "react";

import { Rating } from "../../Rating/Rating";

import {
  emptyVerticalProductCardRating,
  verticalProductCardRating
} from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "rating" | "reviewCount">;
};

export const VerticalProductCardRating: React.FC<Props> = ({ product }) => {
  if (!product.rating)
    return <div className={emptyVerticalProductCardRating} />;

  return (
    <div className={verticalProductCardRating}>
      <Rating
        totalReviews={product.reviewCount}
        ratingValue={product.rating}
        renderCountAsLink={false}
      />
    </div>
  );
};
